import {
  BACKGROUNDS,
  BRAND,
  BRAND_PRIMARY_SCALE,
} from "../colors";
import { ProtonColorScale, ProtonPalette } from "../types";

const LIGHT_GRAY = "#DDDDDD";
export const BORDER = LIGHT_GRAY;
export const ELEVATION = "#F7F8F9";
export const LIGHT_GRAYSCALE: ProtonColorScale = {
  SUPER_DARK: "#141211",
  DARK: "#4D4D4D",
  MEDIUM: "#7D7D7D",
  MEDIUM_LIGHT: "#B1B1B1",
  LIGHT: LIGHT_GRAY,
  LIGHTEST: "#F0F1F2",
  SUPER_LIGHT: ELEVATION,
  WHITE: "#FFFFFF",
};

export const LIGHT_SECONDARY_SCALE: ProtonColorScale = {
  SUPER_DARK: "#032026",
  DARK: "#084657",
  MEDIUM: "#2085BA",
  MEDIUM_LIGHT: "#44A8EB",
  LIGHT: "#70B9F6",
  LIGHTEST: "#9DCBFC",
  SUPER_LIGHT: "#C8DFFF",
  WHITE: "#f5f9ff",
};

export const LIGHT_PALETTE: ProtonPalette = {
  BASE_COLOR: BACKGROUNDS.WHITE,
  BRAND,
  GRAYSCALE: LIGHT_GRAYSCALE,
  PRIMARY: BRAND_PRIMARY_SCALE,
  SECONDARY: LIGHT_SECONDARY_SCALE,
};
